import React, { useState } from 'react';
import './EmergencyResources.css';

const RESOURCES = [
  {
    category: 'Emergency Services',
    icon: '🆘',
    items: [
      { name: 'National Emergency Number', number: '112', desc: 'Police, Fire, Ambulance — works across India', priority: true },
      { name: 'Indian Coast Guard (MRCC)', number: '1554', desc: '24/7 maritime search & rescue, oil spill response', priority: true },
      { name: 'NDMA Helpline', number: '1078', desc: 'National Disaster Management Authority — floods, storms, tsunami' },
      { name: 'Police', number: '100', desc: 'For reporting crimes including illegal fishing, poaching' },
    ]
  },
  {
    category: 'Wildlife & Animal Rescue',
    icon: '🐢',
    items: [
      { name: 'Wildlife SOS', number: '1800-599-4442', desc: 'Stranded marine animals, injured wildlife rescue', priority: true },
      { name: 'SPCA India', number: '011-2379-6928', desc: 'Animal cruelty and rescue' },
      { name: 'Forest Department', number: '1800-425-1515', desc: 'Protected species, wildlife crime reporting' },
      { name: 'Mangrove Foundation', number: '022-2202-0942', desc: 'Mangrove & coastal wildlife conservation (Maharashtra)' },
    ]
  },
  {
    category: 'Environment & Pollution',
    icon: '🏭',
    items: [
      { name: 'CPCB Helpline', number: '1800-180-4999', desc: 'Central Pollution Control Board — report pollution, dumping' },
      { name: 'MoEFCC', number: '011-2469-5386', desc: 'Ministry of Environment — policy & major environmental issues' },
      { name: 'NGT Filing', number: '011-2338-2012', desc: 'National Green Tribunal — file environmental complaints' },
      { name: 'Coastal Zone Management', number: '044-2220-0600', desc: 'NCSCM — coastal regulation zone violations' },
    ]
  },
  {
    category: 'Weather & Safety',
    icon: '🌊',
    items: [
      { name: 'IMD Cyclone Warning', number: '1800-180-1717', desc: 'Indian Meteorological Department — weather forecasts & warnings' },
      { name: 'INCOIS Tsunami Warning', number: '040-2388-6000', desc: 'Indian National Centre for Ocean Information Services' },
      { name: 'Fishermen Safety', number: '1093', desc: 'Deep sea fishing safety alerts (varies by state)' },
    ]
  },
  {
    category: 'NGOs & Organizations',
    icon: '🌍',
    items: [
      { name: 'WWF India', number: '011-4150-4814', desc: 'World Wildlife Fund — conservation programs & reporting' },
      { name: 'Greenpeace India', number: '080-4615-0001', desc: 'Environmental campaigns and activism support' },
      { name: 'ReefWatch Marine Conservation', number: '080-4653-7557', desc: 'Coral reef monitoring & marine conservation' },
      { name: 'Ocean Conservancy', number: 'oceanconservancy.org', desc: 'International ocean protection & cleanup programs', isWeb: true },
    ]
  },
];

const EmergencyResources = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredResources = RESOURCES.map(cat => ({
    ...cat,
    items: cat.items.filter(item =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.desc.toLowerCase().includes(searchQuery.toLowerCase())
    )
  })).filter(cat => cat.items.length > 0);

  return (
    <div className="emergency-page">
      <div className="emergency-container">
        <div className="emergency-header">
          <span className="emergency-badge">📞 Help Directory</span>
          <h1>Emergency Resources</h1>
          <p className="emergency-subtitle">Quick access to all ocean, wildlife, and coastal emergency helplines across India.</p>
          
          <div className="emergency-search">
            <span className="search-icon-em">🔍</span>
            <input 
              type="text" 
              placeholder="Search by name or keyword..." 
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {/* SOS Banner */}
        <div className="sos-banner">
          <div className="sos-content">
            <h2>🆘 Immediate Emergency?</h2>
            <p>Call now — these lines are available 24/7</p>
          </div>
          <div className="sos-buttons">
            <a href="tel:112" className="sos-call">
              <span className="sos-number">112</span>
              <span className="sos-label">Emergency</span>
            </a>
            <a href="tel:1554" className="sos-call coast">
              <span className="sos-number">1554</span>
              <span className="sos-label">Coast Guard</span>
            </a>
            <a href="tel:1078" className="sos-call ndma">
              <span className="sos-number">1078</span>
              <span className="sos-label">Disaster Mgmt</span>
            </a>
          </div>
        </div>

        {/* Resource Categories */}
        {filteredResources.map((cat, ci) => (
          <div key={ci} className="resource-category">
            <h2 className="category-title">
              <span>{cat.icon}</span> {cat.category}
            </h2>
            <div className="resource-grid">
              {cat.items.map((item, ii) => (
                <a 
                  key={ii} 
                  href={item.isWeb ? `https://${item.number}` : `tel:${item.number}`}
                  target={item.isWeb ? '_blank' : undefined}
                  rel={item.isWeb ? 'noopener noreferrer' : undefined}
                  className={`resource-card ${item.priority ? 'priority' : ''}`}
                >
                  <div className="resource-top">
                    <h3>{item.name}</h3>
                    {item.priority && <span className="priority-badge">24/7</span>}
                  </div>
                  <p className="resource-desc">{item.desc}</p>
                  <div className="resource-number">
                    <span>{item.isWeb ? '🌐' : '📞'}</span>
                    <span>{item.number}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        ))}

        {filteredResources.length === 0 && (
          <div className="no-results-em">
            <span>🔍</span>
            <p>No resources found for "{searchQuery}". Try a different keyword.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmergencyResources;
